// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1GRnx","select":"Header_select__2y3Ib","clinic":"Header_clinic__1DQVE"};